<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Factuur schema</h2>
                <div class="box-tools">
                    <div class="btn-group">
                        <v-select
                            v-model="teams.selected.value"
                            :options="teams.selectData"
                            :reduce="entry => entry.value"
                            @input="updateTeamSelected"
                            style="min-width:125px"
                            placeholder="Team filter"
                        ></v-select>
                    </div>
                    <div class="btn-group btn-group-xs" v-if="Object.keys(getSpanningYears).length > 1">
                        <button
                            class="btn btn-default btn-xs"
                            v-for="(colspan, year) in getSpanningYears"
                            v-text="year"
                            @click="setYearView(year)"
                        ></button>
                    </div>
                    <div class="btn-group btn-group-xs">
                        <button class="btn btn-default" @click="moveBackwardsYear()" data-tooltip="tooltip" title="Een jaar terug"><i class="fa fa-angle-double-left"></i></button>
                        <button class="btn btn-default" @click="moveBackwards()" data-tooltip="tooltip" title="Een maand terug"><i class="fa fa-angle-left"></i></button>
                        <button class="btn btn-default" @click="moveReset()" v-show="isResetable" data-tooltip="tooltip" title="Terugzetten">Reset</button>
                        <button class="btn btn-default" @click="moveForward()" data-tooltip="tooltip" title="Een maand vooruit"><i class="fa fa-angle-right"></i></button>
                        <button class="btn btn-default" @click="moveForwardYear()" data-tooltip="tooltip" title="Een jaar vooruit"><i class="fa fa-angle-double-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover table-condensed table-bordered centered-table-headers table-fixed">
                    <thead>
                        <tr>
                            <th rowspan="2">Project</th>
                            <th rowspan="2">Task</th>
                            <th rowspan="2" style="width:80px;">Contract fee</th>
                            <th rowspan="2" style="width:80px;">Invoiced</th>
                            <th rowspan="2" style="width:80px;" v-tooltip="'De \'Nog te realiseren omzet\' pagina bevat totalen'">Remaining</th>
                            <th v-for="(colspan, year) in getSpanningYears" :colspan="colspan">{{ year }}</th>
                            <th rowspan="2">Totaal <i class="fa fa-question-circle" data-tooltip="tooltip" title="Totaal van dit overzicht"></i></th>
                        </tr>
                        <tr>
                            <th v-for="(n, addmonth) in 12" :class="{'bg-info':isCurrentMonth(addmonth)}">{{ moment(startperiod).add(addmonth, "month").format("MMM") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="18"><strong>Salesinvoices</strong></td>
                        </tr>
                        <tr v-for="task in teams.selected.salesInvoices">
                            <td>{{ task.project }}</td>
                            <td>{{ task.task }}</td>
                            <td class="text-right">{{ task.contract_fee | toCurrency(false) }}</td>
                            <td class="text-right">{{ task.invoiced | toCurrency(false) }}</td>
                            <td class="text-right">{{ task.remaining | toCurrency(false) }}</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in task.invoices"
                                    v-if="invoiceInMonth(invoice, addmonth) && excludedinvoices.indexOf(invoice.uuid) === -1"
                                    @click="openInvoicesModal(task, invoice)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    :title="getInvoiceAnchorTitle(invoice)"
                                    style="display:block;"
                                >
                                    {{ invoice.sub_total | toCurrency(false) }}
                                </a>
                            </td>
                            <td style="max-width:80px;width:80px;" class="text-right">{{ getTaskTotal(task) | toCurrency(false) }}</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="5" class="text-right">Total project invoice:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalsForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getInvoiceTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="18">&nbsp;</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="18"><strong>Purchaseinvoices</strong></td>
                        </tr>
                        <tr v-for="task in teams.selected.purchaseInvoices">
                            <td>{{ task.project }}</td>
                            <td>{{ task.task }}</td>
                            <td class="text-right">{{ task.contract_fee | toCurrency(false) }}</td>
                            <td class="text-right">{{ task.invoiced | toCurrency(false) }}</td>
                            <td class="text-right">{{ task.remaining | toCurrency(false) }}</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in task.invoices"
                                    v-if="invoiceInMonth(invoice, addmonth)"
                                    @click="openInvoicesModal(task, invoice)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    :title="getInvoiceAnchorTitle(invoice)"
                                    style="display:block;"
                                >
                                    {{ invoice.sub_total | toCurrency(false) }}
                                </a>
                            </td>
                            <td style="max-width:80px;width:80px;" class="text-right">{{ getTaskTotal(task) | toCurrency(false) }}</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="5" class="text-right">Total cost third:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalCostThirdForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getTotalCostThirdTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="18">&nbsp;</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="18"><strong>Totals</strong></td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-right">Total project invoice:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalsForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getInvoiceTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-right">Total cost third:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalCostThirdForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getTotalCostThirdTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-right">Total invoice - cost third:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalsForMonth(addmonth) - getTotalCostThirdForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ (getInvoiceTotal() - getTotalCostThirdTotal()) | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="18">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-right">Prognose:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getPrognosesForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getPrognosesTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-right">(Prognose + Total invoice) - cost third:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:80px;width:80px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ (getPrognosesForMonth(addmonth) + getTotalsForMonth(addmonth)) - getTotalCostThirdForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ (getPrognosesTotal() + getInvoiceTotal()) - getTotalCostThirdTotal() | toCurrency(false) }}</td>
                        </tr>
                        <tr v-if="totalamounts.totalopen || totalamounts.totalexpired">
                            <td colspan="18">&nbsp;</td>
                        </tr>
                        <tr v-if="totalamounts.totalopen">
                            <td colspan="17" class="text-right">Total openstaand</td>
                            <td class="text-right">{{ totalamounts.totalopen | toCurrency(false) }}</td>
                        </tr>
                        <tr v-if="totalamounts.totalexpired">
                            <td colspan="17" class="text-right">Total verlopen</td>
                            <td class="text-right">{{ totalamounts.totalexpired | toCurrency(false) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="overlay" v-show="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <business-invoice-modal
            ref="invoiceModal"
            @invoice-deleted-uuid="addExcludedInvoiceUuid"
        ></business-invoice-modal>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import BusinessInvoiceModal from './InvoiceModal';
import vSelect from "vue-select";

export default {

    components: {
        BusinessInvoiceModal,
        vSelect,
    },

    computed: {

        defaultStartperiod() {
            return moment().startOf("month").subtract(3, "month");
        },

        getSpanningYears() {
            let years = {};
            for (let i = 0; i < 12; i++) {
                let year = moment(this.startperiod).add(i, "month").format("YYYY");
                if (!years[year]) {
                    years[year] = 0;
                }
                years[year]++;
            }
            return years;
        },

        isResetable() {
            if (this.startperiod === null) {
                return false;
            }
            return this.startperiod.format() !== this.defaultStartperiod.format();
        },

    },

    data() {
        return {
            editinvoice:false,
            excludedinvoices:[],
            loading:true,
            moment:moment,
            prognoses:[],
            purchaseinvoices:[],
            selectedTask:null,
            startperiod:null,
            tasks:[],
            teams: {
                projectData:[],
                selectData:[],
                selected: {
                    salesInvoices:[],
                    purchaseInvoices:[],
                    prognoses:[],
                    value:null,
                },
            },
            totalamounts:[],
        }
    },

    methods: {

        addExcludedInvoiceUuid(invoice_uuid) {
            this.excludedinvoices.push(invoice_uuid);
            this.loading = true;
            this.getInvoiceSchedule();
        },

        calculateTaskInvoicesSubTotal(invoices) {
            let total = 0;
            invoices.forEach(invoice => total += invoice['sub_total']);
            return total;
        },

        calculateSubtotalForType(type, filter) {
            let allInvoices;
            if (type == 'sales') {
                allInvoices =  this.teams.selected.salesInvoices;
            } else {
                allInvoices =  this.teams.selected.purchaseInvoices;
            }

            let total = 0;
            for (const i in allInvoices) {
                let invoices = allInvoices[i].invoices
                if (filter !== undefined) {
                    invoices = invoices.filter(filter);
                }
                total += this.calculateTaskInvoicesSubTotal(invoices);
            }
            return total;
        },

        calculatePrognoses(filter) {
            let total = 0;
            let prognoses = this.teams.selected.prognoses;
            if (filter !== undefined) {
                prognoses = prognoses.filter(filter);
            }
            prognoses.forEach(prognosis => total += prognosis['fee']);
            return total;
        },

        getInvoiceSchedule() {
            axios.get(this.invoiceScheduleUri, {params:{startperiod:this.startperiod.format("YYYY-MM-DD")}})
            .then(resp => {
                this.tasks = resp.data.data.tasks;
                this.purchaseinvoices = resp.data.data.purchaseinvoices;
                this.prognoses = resp.data.data.prognoses;
                this.totalamounts = resp.data.data.totalamounts;
                this.teams.projectData = resp.data.data.teams.project_data;
                this.teams.selectData = resp.data.data.teams.select_data;
                this.teams.selected.salesInvoices = this.tasks;
                this.teams.selected.purchaseInvoices = this.purchaseinvoices;
                this.teams.selected.prognoses = this.prognoses;
                this.loading = false;
            });
        },

        getInvoiceAnchorClass(invoice) {
            if (invoice.overdue === true) {
                return "invoice-is-overdue";
            }
            if (invoice.paid === true) {
                return "invoice-is-paid";
            }
            if (invoice.send === true) {
                return "invoice-is-send";
            }
            return "invoice-is-pending";
        },

        getInvoiceAnchorTitle(invoice) {
            if (invoice.overdue === true) {
                return "Factuur is niet binnen de betaaltermijn voldaan!";
            }
            if (invoice.paid === true) {
                return "Factuur is voldaan";
            }
            if (invoice.send === true) {
                return "Factuur is verzonden";
            }
            return "Te versturen";
        },

        getTaskTotal(task) {
            return this.calculateTaskInvoicesSubTotal(task.invoices);
        },

        getTotalsForMonth(addmonth) {
            if (!this.startperiod) {
                return 0;
            }

            return this.calculateSubtotalForType('sales', invoice => this.invoiceInMonth(invoice, addmonth));
        },

        getPrognosesForMonth(addmonth) {
            if (!this.startperiod || moment().diff(moment(this.startperiod).add(addmonth, "month"),'days') > 0) {
                return 0;
            }

            let theMoment = moment(this.startperiod).add(addmonth, "month");

            return this.calculatePrognoses(prognosis => theMoment.isSame(prognosis.date, 'month'));
        },

        getTotalCostThirdForMonth(addmonth){
            if (!this.startperiod) {
                return 0;
            }

            return this.calculateSubtotalForType('purchase', invoice => this.invoiceInMonth(invoice, addmonth));
        },

        getInvoiceTotal(){
            return this.calculateSubtotalForType('sales');
        },

        getPrognosesTotal(){
            return this.calculatePrognoses(prognosis => moment(prognosis.date).isAfter(moment().endOf('month')));
        },

        getTotalCostThirdTotal() {
            return this.calculateSubtotalForType('purchase');
        },

        invoiceInMonth(invoice, addmonth){
            let timetouse = invoice.date !== null ? invoice.date : invoice.expected_at;
            return moment(timetouse).add(12, "hour").isBetween(
                moment(this.startperiod).add(addmonth, "month").startOf("month"),
                moment(this.startperiod).add(addmonth, "month").endOf("month")
            );
        },

        isCurrentMonth(addmonth) {
            return moment().isBetween(
                moment(this.startperiod).add(addmonth, "month").startOf("month"),
                moment(this.startperiod).add(addmonth, "month").endOf("month")
            );
        },

        move(newstartperiod) {
            this.loading = true;
            this.tasks = [];
            this.startperiod = newstartperiod.startOf("month");
            this.getInvoiceSchedule();
        },

        moveBackwardsYear() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "year"));
        },

        moveBackwards() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "month"));
        },

        moveForward() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "month"));
        },

        moveForwardYear() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "year"));
        },

        moveReset() {
            this.move(this.defaultStartperiod);
        },

        openInvoicesModal(task, invoice) {
            this.$refs.invoiceModal.openModal(task.taskurl, {}, invoice);
        },

        setStartperiod(startperiod) {
            this.startperiod = startperiod;
        },

        setYearView(year) {
            this.move(moment().year(year).startOf("year"));
        },

        updateTeamSelected() {
            if (this.teams.selected.value === null) {
                this.teams.selected.salesInvoices = this.tasks;
                this.teams.selected.purchaseInvoices = this.purchaseinvoices;
                this.teams.selected.prognoses = this.prognoses;
            } else {
                let ret = this.teams.projectData.find(data => data.team_id === this.teams.selected.value);
                this.teams.selected.salesInvoices = this.tasks.filter(task => Object.values(ret.project_uuids).includes(task.project_uuid));
                this.teams.selected.purchaseInvoices = this.purchaseinvoices.filter(task => Object.values(ret.project_uuids).includes(task.project_uuid));
                this.teams.selected.prognoses = this.prognoses.filter(prognosis => Object.values(ret.project_uuids).includes(prognosis.project_uuid));
            }
        },
    },

    mounted() {
        this.setStartperiod(this.defaultStartperiod);
        this.getInvoiceSchedule();
    },

    name:"BusinessInvoiceSchedule",

    props: {
        invoiceScheduleUri: {
            required:true,
            type:String,
        },
    }

}

</script>

<style>

    table.centered-table-headers thead th,
    table.centered-table-headers thead td {
        text-align:center;
    }

    a.invoice-is-overdue { color:red; }
    a.invoice-is-paid { color:green; }
    a.invoice-is-send { color:blue; }
    a.invoice-is-pending { color:black; }

</style>
